import "./skills-card.css";

const SkillsCard = ({ cardName, cardImage, name, data }) => {
  return (
    <div
      className={`${cardName} skills-card-container d-flex justify-content-center align-items-center`}
    >
      <div className="skills-card-content d-flex justify-content-center align-items-center">
        <img
          className="skills-card-content-img"
          src={cardImage}
          alt={`${name}-icon`}
        />
        <div>
          <h5 className="skills-card-content-header">{name}</h5>
          <p className="skills-card-content-skills">
            {data.map((item, index) =>
              index === data.length - 1 ? item : item + ", "
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SkillsCard;
